'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');let

GroupsCommandAndQueryService=class GroupsCommandAndQueryService extends BaseService{
constructor(socketService){
super();
this._socketService=socketService;
}

async _getGroupsCore(messageType){
let response=await this._socketService.sendAndWaitForResponse(messageType);
if(!SocketResponse.succeeded(response)){
throw new Error('Unexpected error getting groups.');
}

return response.body.items;
}

getGroupTree(){
return this._getGroupsCore('GetGroupTree');
}

getFlattenedGroups(){
return this._getGroupsCore('GetFlattenedGroups');
}};


module.exports=GroupsCommandAndQueryService;
//# sourceMappingURL=groupsCommandAndQueryService.js.map
